import { DATE_FORMAT } from "../../Utils/date_utils";
import { INITIALIZE_STORE } from "../actions/manager.actions";
import {
	PLAYER_SET_COST_PER_MIN,
	PLAYER_SET_FILTER,
	PLAYER_SET_LOADING,
	PLAYER_SET_PRACTICE_PLAN,
	PLAYER_SET_TESTING_RADAR_METRICS,
	PLAYER_SET_TESTING_DATA,
	PLAYER_SET_TESTING_RADAR_DATA,
	PLAYER_SET_TRAININGS,
	PLAYER_SET_TESTING_STATS,
	PLAYER_SET_CHARTS,
	PLAYER_SET_TESTING_STAT_DEFAULTS,
	PLAYER_SET_FP_DATA,
	PLAYER_SET_FPMS_DATA,
	PLAYER_SET_FP_METRICS,
} from "../actions/player.actions";
import moment from "moment";

const initialState = {
	loading: {},
	costPerMin: [],
	filter: {
		showGameDays: false,
		showPredictions: false,
		showWeekly: false,
		startDate: moment().subtract(2, "weeks").format(DATE_FORMAT),
		endDate: moment().format(DATE_FORMAT),
		player: null,
		session: null,
		testingStats: false,
	},
	trainings: { data: [], metrics: [], wellness_metrics: [] },
	practicePlan: [],
	testingStatDefaults: [],
	forceplateStatDefaults: [],
	wellnessStatDefaults: [],
	gpsStatDefaults: [],
	nutritionStatDefaults: [],
	testingData: {
		key_stats: [],
		std_dev: [],
		data: [],
		options: [],
		optionsV2: [],
	},
	testingRadarData: {
		avg_perc_change: null,
		data: [],
		last_perc_change: null,
	},
	radarMetrics: [],
	playerCharts: {
		aerobic: null,
		movementSignature: null,
	},
	fpData: { data: [], key_stats: [], optionsV2: [] },
	fpMetrics: ["jump_height", "mRSI", "load", "explode"],
};

export const playerReducer = (state = initialState, action) => {
	switch (action.type) {
		case PLAYER_SET_LOADING:
			return { ...state, loading: { ...state.loading, ...action.data } };
		case PLAYER_SET_COST_PER_MIN:
			return { ...state, costPerMin: action.data };
		case PLAYER_SET_FILTER:
			return { ...state, filter: { ...state.filter, ...action.data } };
		case PLAYER_SET_TRAININGS:
			return { ...state, trainings: action.data };
		case PLAYER_SET_PRACTICE_PLAN:
			return { ...state, practicePlan: action.data };
		case PLAYER_SET_TESTING_DATA:
			return { ...state, testingData: action.data };
		case PLAYER_SET_TESTING_RADAR_DATA:
			return { ...state, testingRadarData: action.data };
		case PLAYER_SET_TESTING_RADAR_METRICS:
			return { ...state, radarMetrics: action.data };
		case PLAYER_SET_TESTING_STAT_DEFAULTS:
			return { ...state, testingStatDefaults: action.data };
		case PLAYER_SET_FP_DATA:
			return { ...state, fpData: action.data };
		case PLAYER_SET_FPMS_DATA:
			return { ...state, fpmsData: action.data };
		case PLAYER_SET_FP_METRICS:
			return { ...state, fpMetrics: action.data };
		case PLAYER_SET_CHARTS:
			return { ...state, playerCharts: {
				...state.playerCharts,
				[action.chartType]: action.data
			} };
		case INITIALIZE_STORE:
				return initialState;
		default:
			return state;
	}
};
